
import { Product } from "@/types/product";

export const vpxTC1WP2: Product = {
  id: "vpx-tc1-wp-2",
  groupId: "avoip",
  name: "VPX-TC1-WP-2",
  subtitle: "1Gb Wall Plate Transceiver",
  description: "The VPX-TC1-WP-2 is an innovative dual-input wall plate transmitter that brings the power of Aurora's 1G AV over IP technology to a convenient in-wall form factor. This versatile solution features two HDMI 2.0 inputs with auto-switching capability, making it perfect for conference rooms, classrooms, and other presentation spaces.\n\nDesigned for ease of installation, the wall plate integrates seamlessly into a standard 2-gang electrical box and is powered via PoE for simplified deployment. The unit includes a local HDMI output for confidence monitoring or local display, along with comprehensive audio integration options.\n\nThe VPX-TC1-WP-2 maintains all the advanced features of the VPX series, including 4K60 4:4:4 support, zero latency, and compatibility with the entire VPX ecosystem, while offering the convenience of a wall-mounted solution.",
  features: [
    "4K60 4:4:4 UHD 120m over 1G CAT 5e",
    "Zero Frame Latency (1.78ms)",
    "HDR10, HDR10+, Dolby Vision",
    "LPCM up to 12-channels, Dolby Digital Plus, Dolby TrueHD DTS HD Master Audio, Dolby ATMOS",
    "12 bits color depth processing, 16bits OSD",
    "Enterprise Security (AES 256, 802.1x, HTTPS, & SSH)",
    "Seamless Switching, Video Wall and Image Rotation",
    "EPG & Channel Mapping",
    "MJPEG Preview up to 720p30",
    "1 HDMI Inputs, 1 USB-C Video/Data",
    "USB 2.0 Type A",
    "Line In/Out on Rear for Add-on Audio Wall Plates",
    "1G LAN PoE",
    "RS-232 Serial Port",
    "Integrated Web Server for Configuration",
    "AES67 Included",
    "Dante® 2 Ch Audio License Option",
    "Low Power at 8 Watts",
    "2 Gang Mounting Available in White and Black"
  ],
  specifications: [
    "Compression: Mimix™ 13:1",
    "Latency: 0 Frame (1.78ms) with Ultra Low Latency Mode",
    "Video Inputs: 1 HDMI 2.0b, 1 USB-C",
    "Encryption: HDCP 2.3 & AES 256",
    "Audio Analog: Stereo Line In/Out (3.5mm TRS)",
    "1G Ethernet: RJ-45 and SFP",
    "LAN: RJ-45 10/100/1000M PoE",
    "Video Bandwidth: 600MHz",
    "Video Support: Up to 4K2K 4:4:4 @ 60Hz",
    "Audio Support: Up to 12 Channels",
    "Video Stream Bandwidth: 93Mbps – 850Mbps (4K60 4:4:4) Packet Size Under 1600",
    "1Gbps with USB and Audio",
    "USB Bandwidth: 200Mbps (Camera), 170Mbps (HID/Mass Storage Devices)",
    "RS-232: Up to 115k Baud (3.5mm TRS)",
    "IR: Bi-Directional (3.5mm TRS)",
    "USB Connector: 1 USB 2.0 Type A & 1 USB 2.0 Type-C",
    "Options: Dante® 2Ch License",
    "Interface: IR or Keyboard via OSD, Web Server",
    "Housing: Aluminum Enclosure",
    "Dimensions (L x W x H): 3.728\" x 2.83\" (4.331\" with tabs) x 1.404\"",
    "Weight: 2.5lbs (1.13g)",
    "Mounting: 2 Gang Decora Style",
    "Power Supply: 48v DC (2 Pin Euro) or PoE (LAN)",
    "Power Consumption: 6.4 Watts, up to 12.9 Watts with USB",
    "Operation Temperature: 0~40o C [32~104o F]",
    "Storage Temperature: -20~60o C [-4~140o F]",
    "Relative Humidity: 20~90% RH [No Condensation]",
    "Package Contents: VPX-TC1-WP2-PRO"
  ],
  images: [
    "/lovable-uploads/6f24a59b-49a6-4019-ba6d-642207f2136a.png",
    "/lovable-uploads/f3f20e21-f199-4734-8826-d51402807584.png"
  ],
  videoUrl: "https://youtu.be/dAolV2vTp9c?si=KpcEs38V7Kl8rVVe",
  slug: "vpx-tc1-wp-2",
  networkSpeed: "1gb"
};
